import { GetStaticPaths } from 'next';
import AuthorNextPage, { getStaticProps } from '..';

export { getStaticProps };

export const getStaticPaths: GetStaticPaths = () => ({
  fallback: 'blocking',
  paths: [],
});

export default AuthorNextPage;
